import "./mobileMenu.styles.css";
import React, { useRef } from "react";
import { Link } from "react-router-dom";
import CloseIcon from "../../svg/close";
import BackToIcon from "../../svg/backTo";
import useClickOutside from "../../helpers/clickOutside.helper";
import { products } from "../../data/products";

const MobileDropdown = ({
  setShowMobileDropdown,
  setShowMobileMenu,
  handleClose,
  showMobileDropdown,
}) => {
  const handleBack = () => {
    setShowMobileDropdown(false);
    setShowMobileMenu(true);
  };

  const mobileDropMenu = useRef(null);
  useClickOutside(mobileDropMenu, () => {
    setShowMobileDropdown(false);
  });

  const groupedProducts = products.reduce((acc, product) => {
    if (!acc[product.category]) {
      acc[product.category] = [];
    }
    acc[product.category].push(product.name);
    return acc;
  }, {});

  return (
    <div 
      className={`mobile-menu ${showMobileDropdown ? "mobile-menu-open" : "mobile-menu-close"}`}
      ref={mobileDropMenu} 
      role="navigation" 
      aria-label="Products dropdown menu"
      aria-hidden={!showMobileDropdown}
    >
      <div className="mobile-menu-btns">
        <button className="back-to-menu" onClick={handleBack} aria-label="Back to main menu">
          <BackToIcon />
        </button>
        <button className="close-menu" onClick={handleClose} aria-label="Close menu">
          <CloseIcon />
        </button>
      </div>

      <ul className="submenu scrollbar2">
        <div className="dropDown-header">Products</div>
        {Object.entries(groupedProducts).map(([category, productNames]) => (
          <li key={category} className="list-group">
            <h5>
              <Link
                to={`products/${category.toLocaleLowerCase()}`}
                className="nav-link-header"
                onClick={handleClose}
              >
                {category}
              </Link>
            </h5>

            <ul>
              {productNames?.map((name, idx) => (
                <li key={`${category}-${name}-${idx}`} to="/products/">
                  <Link to={`/product/${name}`} onClick={handleClose}>
                    {name}
                  </Link>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MobileDropdown;
